import axios from "axios";
import { MAIN_URL } from "../../API/Api";

const GetAllContractors = async (token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    }
    const response = await axios({
        method: "GET",
        baseURL: `${MAIN_URL}/contractors`,
        headers,
    })

    return response.data
}

const SearchONContractors = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    }

    const response = await axios({
        method: "GET",
        baseURL: `${MAIN_URL}/admin/contractors/search`,
        headers,
        params: data
    })
    return response.data;
}

const GetSingleContractor = async (id, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    }
    const response = await axios({
        method: "GET",
        baseURL: `${MAIN_URL}/admin/contractors/${id}`,
        headers,
    })
    return response.data;
}

const CreateNewContractor = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    }
    const response = await axios({
        method: "POST",
        baseURL: `${MAIN_URL}/contractors`,
        headers,
        data: data,
    })
    return response.data
}

const UpdateContractorData = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    }
    const response = await axios({
        method: "PUT",
        baseURL: `${MAIN_URL}/admin/contractors/edit`,
        headers,
        data: data,
    })
    return response.data
}

const DeleteContractorAction = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    }

    const response = await axios({
        method: "DELETE",
        baseURL: `${MAIN_URL}/admin/contractors/delete`,
        headers,
        data: { ...data },
    })

    return response.data
}

const ContractorService = {
    GetAllContractors,
    SearchONContractors,
    CreateNewContractor,
    GetSingleContractor,
    UpdateContractorData,
    DeleteContractorAction,
}

export default ContractorService;